// src/ConsumerApp/api/offers/discounts.hooks.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { DiscountService } from './discounts.service';

export const useGetDiscountsByCustomer = (customerId) => {
  return useQuery({
    queryKey: ['discounts', customerId],
    queryFn: async () => {
      const response = await DiscountService.getDiscountsByCustomer(customerId);
      return response.data || response;
    },
    enabled: !!customerId,
    staleTime: 1000 * 60 * 5,
  });
};

export const useApplyDiscount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => DiscountService.applyDiscount(payload),
    onSuccess: (data, variables) => {
      const customerId = variables?.consumer?.customer_id || variables?.consumer?.consumer_id;
      if (customerId) {
        queryClient.invalidateQueries({ queryKey: ['bucketSummary', customerId] });
        queryClient.invalidateQueries({ queryKey: ['bucketDetails', customerId] });
      }
    },
  });
};

export const useRemoveDiscount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => DiscountService.removeDiscount(payload),
    onSuccess: (data, variables) => {
      const customerId = variables?.consumer?.customer_id || variables?.consumer?.consumer_id;
      if (customerId) {
        queryClient.invalidateQueries({ queryKey: ['bucketSummary', customerId] });
        queryClient.invalidateQueries({ queryKey: ['bucketDetails', customerId] });
      }
    },
  });
};

export const useEvaluateDiscounts = () => {
  return useMutation({
    mutationFn: (payload) => DiscountService.evaluateDiscounts(payload),
  });
};